import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { reduceAmount } from '@shared/utils/reduce-price-symbols';
import { isNil } from 'lodash';

@Component({
    selector: 'app-range-input',
    templateUrl: './range-input.component.html',
    styleUrls: ['./range-input.component.less'],
    standalone: false,
})
class RangeInputComponent implements OnChanges {

    @Input() title: string = '';

    @Input() defaultAreaTitle = '';

    @Input() stepInput: number = 1;

    @Input() valueMin: number = null;

    @Input() valueMax: number = null;

    @Input() suffix: string = '';

    @Input() type: string = '';

    @Input() resetFlag: boolean = false;

    @Output() valueChanged: EventEmitter<number[]> = new EventEmitter<number[]>();

    @Output() labelChanged: EventEmitter<string> = new EventEmitter<string>();

    @Output() valuesCleared: EventEmitter<string> = new EventEmitter<string>();


    //RegEx is the default title customized for the area filter
    labelDefSquare = /\s*\(.*?\)\s*/g;

    label: string = '';

    labelWithoutTitle: string = '';

    valueFrom = null;

    valueTo = null;

    rangeValuesTotal = [this.valueFrom, this.valueTo];

    rangeForm: FormGroup;


    constructor(private fb: FormBuilder) {
        this.rangeForm = this.fb.group({
            valueFrom: [null],
            valueTo: [null],
        });

        this.rangeForm.valueChanges.subscribe(values => {
            this.rangeValuesTotal = [this.rangeForm.get('valueFrom').value, this.rangeForm.get('valueTo').value];
            this.updateLabel();
            this.emitChanges();
        });
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes.resetFlag && this.resetFlag) {
            this.clearValues();
        }
    }

    updateValueFrom(value: number) {
        this.valueFrom = this.validateValue(value);
        this.rangeForm.get('valueFrom')
            .setValue(value, { emitEvent: false });
        this.rangeValuesTotal[0] = value;
        this.updateLabel();
        this.emitChanges();
    }

    updateValueTo(value: number) {
        value = this.validateValue(value);
        this.rangeForm.get('valueTo')
            .setValue(value, { emitEvent: false });
        this.rangeValuesTotal[1] = value;
        this.updateLabel();
        this.emitChanges();
    }

    updateRangeValuesTotal(event) {
        this.rangeValuesTotal = event;
        this.valueFrom = this.rangeValuesTotal[0] === this.valueMin
            ? null
            : this.rangeValuesTotal[0];
        this.valueTo = this.rangeValuesTotal[1] === this.valueMax
            ? null
            : this.rangeValuesTotal[1];
        this.updateLabel();
        this.emitChanges();
    }

    updateLabel() {
        if (this.type === 'area') {
            this.title = this.title.replace(this.labelDefSquare, '');
        }

        const [from, to] = this.rangeValuesTotal;

        if (!isNil(from) && !isNil(to)) {
            const valueFrom = reduceAmount(from);
            const valueTo = reduceAmount(to);
            this.label = `${this.title} от ${valueFrom} ${this.suffix} - до ${valueTo} ${this.suffix}`;
        } else if (!isNil(from)) {
            const valueFrom = reduceAmount(from);
            this.label = `${this.title} от ${valueFrom} ${this.suffix}`;
        } else if (!isNil(to)) {
            const valueTo = reduceAmount(to);
            this.label = `${this.title}  до ${valueTo} ${this.suffix}`;
        } else {
            this.label = '';
            if (this.type === 'area') {
                this.title = this.defaultAreaTitle;
            }
        }

        this.labelWithoutTitle = this.label.replace(this.title, '')
            .trim();
    }

    emitChanges() {
        this.valueChanged.emit(this.rangeValuesTotal);
        this.labelChanged.emit(this.label);
        this.valuesCleared.emit();
    }

    validateValue(value: number): number {
        if (value < this.valueMin) {
            value = this.valueMin;
        }
        if (value > this.valueMax) {
            value = this.valueMax;
        }

        return value;
    }

    submitForm() {
        console.log('Submitted with range:', this.rangeValuesTotal);
    }

    clearValues() {
        this.valueFrom = null;
        this.valueTo = null;
        this.rangeValuesTotal = [this.valueTo = null, this.valueFrom = null];
        this.updateLabel();
        this.emitChanges();
    }
}


export default RangeInputComponent;
